import gql from 'graphql-tag';

export const GET_SITES = gql`
query getSites {
    getSites{
     sites {
       locationName
       locationId
     }
   }
 }
`;
